/* per page number of records constants */

export const PER_PAGE_TEN_RECORDS = 10;
export const PER_PAGE_FIFTEEN_RECORDS = 15;
